import { render, staticRenderFns } from "./CalendarBlock.vue?vue&type=template&id=d9acb040&"
import script from "./CalendarBlock.vue?vue&type=script&lang=js&"
export * from "./CalendarBlock.vue?vue&type=script&lang=js&"
import style0 from "./CalendarBlock.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports